import { useState, type FormEvent } from 'react';
import { useSearchParams } from 'react-router-dom';
import { BandeauAlerte, BandeauSignature, Champ, Embleme } from '../../components/index.js';
import { api } from '../../lib/api.js';

/** Connexion organisateur par lien magique (e-mail + lien à usage unique). */
export function Connexion() {
  const [params] = useSearchParams();
  const [email, setEmail] = useState('');
  const [etat, setEtat] = useState<'saisie' | 'envoi' | 'envoye' | 'erreur'>('saisie');
  const lienInvalide = params.get('erreur') === 'lien';

  const envoyer = async (e: FormEvent) => {
    e.preventDefault();
    if (!email.includes('@')) return;
    setEtat('envoi');
    try {
      await api.post('/api/auth/magic-link', { email });
      setEtat('envoye');
    } catch {
      setEtat('erreur');
    }
  };

  return (
    <div className="page-connexion">
      <div className="carte-connexion">
        <Embleme grand />
        <BandeauSignature petit />
        <h1 className="display" style={{ fontSize: 32 }}>
          Espace organisateur
        </h1>
        <p className="texte-doux texte-long">Indiquez votre e-mail : vous recevrez un lien de connexion, valable quinze minutes. Pas de mot de passe à retenir.</p>
        {lienInvalide && etat === 'saisie' ? (
          <BandeauAlerte niveau="attention" role="alert" titre="Ce lien n'est plus valable.">
            Il a déjà servi ou a expiré. Demandez-en un nouveau.
          </BandeauAlerte>
        ) : null}
        {etat === 'envoye' ? (
          <BandeauAlerte niveau="ok" titre="C'est parti." role="status">
            Si l'adresse {email} est connue ou nouvelle, un lien de connexion vient de partir. Ouvrez-le depuis cet appareil.
          </BandeauAlerte>
        ) : (
          <form onSubmit={envoyer} className="pile" noValidate>
            <Champ id="email" label="E-mail" type="email" autoComplete="email" inputMode="email" value={email} onChange={(ev) => setEmail(ev.target.value)} required />
            {etat === 'erreur' ? (
              <BandeauAlerte niveau="attention" role="alert" titre="Envoi impossible.">
                Réessayez dans un instant.
              </BandeauAlerte>
            ) : null}
            <button type="submit" className="btn principal large" disabled={etat === 'envoi' || !email.includes('@')}>
              {etat === 'envoi' ? 'Envoi…' : 'Recevoir mon lien de connexion'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
